/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql } from "gatsby"
import { useTranslation } from "react-i18next"

import PageWrap from "../components/atoms/PageWrap"
import AnimateInView from "../components/atoms/AnimateInView"
import SEO from "../components/molecules/SEO"

import JoinIn from "../components/organisms/JoinIn"

import { getResolvedLocale, getDataForLocale } from "../utils/i18n"

const JoinInPage = ({ location, data: { sanityJoinIn } }) => {
  const { i18n } = useTranslation()
  const resolvedLocale = getResolvedLocale(i18n)
  const { title } = getDataForLocale(sanityJoinIn, resolvedLocale)

  return (
    <PageWrap sx={{ my: [6, 7], mx: "auto", maxWidth: 800 }}>
      <SEO title={title} pathname={location.pathname} />
      <AnimateInView y="0">
        <JoinIn />
      </AnimateInView>
    </PageWrap>
  )
}

export default JoinInPage

export const pageQuery = graphql`
  query JoinInPage {
    sanityJoinIn {
      title {
        ...StringAllLanguages
      }
    }
  }
`
